import type { CSSProperties, ReactNode } from 'react';
import type { ForwardedRef } from 'react';
import styled, { css } from 'styled-components';

export const BookChaptersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 1200px;
`;

export const ImageColumn = styled.div`
  position: relative;
  aspect-ratio: 7/10;
  width: 100%;

  @media ${({ theme }) => theme.media.desktop} {
    aspect-ratio: unset;
  }
`;

export const ImageWrapper = styled.div<{
  children: ReactNode;
  ref: ForwardedRef<HTMLDivElement>;
  style: CSSProperties;
}>`
  position: relative;
  aspect-ratio: 7/10;

  @media ${({ theme }) => theme.media.desktop} {
    position: sticky;
    top: 18px;
  }

  img {
    transition: opacity 0.3s ease;
  }
`;

export const ContentColumn = styled.div``;

export const ChapterList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

interface ChapterItemProps {
  children: ReactNode;
  'data-active'?: boolean;
  isLast?: boolean;
  onClick?: () => void;
}

export const ChapterItem = styled.div.attrs<ChapterItemProps>(props => ({
  'data-active': props['data-active'],
}))<ChapterItemProps>`
  display: flex;
  flex-direction: column-reverse;
  gap: 1.5rem;
  border-radius: 1rem;
  opacity: 1;
  transform: none;
  cursor: pointer;

  @media ${({ theme }) => theme.media.desktop} {
    gap: initial;
    opacity: 0.5;
    transition: opacity 0.3s ease;
    flex-direction: column;
    margin-bottom: 160px;

    &[data-active='true'] {
      opacity: 1;
    }

    ${({ isLast }) =>
      isLast &&
      css`
        margin-bottom: 300px;
      `}
  }
`;

export const ChapterTitle = styled.h3`
  font-size: 24px;
  line-height: 1.2;
  margin-bottom: 16px;
  width: fit-content;
  position: relative;

  @media ${({ theme }) => theme.media.desktop} {
    &::after {
      content: '';
      position: absolute;
      bottom: -4px;
      left: 0;
      width: 0;
      height: 2px;
      background: ${({ theme }) => theme.palette.orange};
      transition: width 0.6s ease;
    }

    ${ChapterItem}[data-active='true'] & {
      &::after {
        width: 100%;
      }
    }
  }
`;

export const ChapterDescription = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  color: #444;
`;

export const MobileLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media ${({ theme }) => theme.media.desktop} {
    display: none;
  }
`;

export const DesktopLayout = styled.div`
  display: none;

  @media ${({ theme }) => theme.media.desktop} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 32px;
  }
`;
